import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {ActionResult, Waypoint, WaypointType} from "@model";
import {Observable, map} from "rxjs";
import {EnvironmentService} from "./environment.service";

@Injectable({ providedIn:'root' })
export class WaypointService {

  constructor(private http: HttpClient, private environmentService:EnvironmentService) {
  }

  findWaypoints(raceId: number | undefined): Observable<Waypoint[]> {
    return this.http.post<ActionResult<Waypoint[]>>(this.environmentService.getApiUrl() + "/api/public/waypoint/race/fetch", raceId).pipe(
      map((actionResult: ActionResult<Waypoint[]>) => {
        if (actionResult.resultCode !== -1) {
          return this._sortWaypoints(actionResult.result ?? []);
        } else {
          return [];
        }
      }));
  }

  updateWaypoint(waypoint: Waypoint, onSuccess: () => void, onError: () => void): void {
    this.http.post<ActionResult<boolean>>
    (this.environmentService.getApiUrl() + (waypoint.id ? "/api/waypoint/update" : "/api/waypoint/add"), waypoint)
      .subscribe((actionResult: ActionResult<boolean>) => {
        if (actionResult.resultCode !== -1) {
          onSuccess();
        } else {
          onError();
        }
      });
  }

  deleteWaypoint(waypoint: Waypoint, onSuccess: () => void, onError: () => void): void {
    this.http.post<ActionResult<boolean>>
    (this.environmentService.getApiUrl() + "/api/waypoint/delete", waypoint.id)
      .subscribe((actionResult: ActionResult<boolean>) => {
        if (actionResult.resultCode !== -1) {
          onSuccess();
        } else {
          onError();
        }
      });
  }

  _sortWaypoints(waypoints: Waypoint[]): Waypoint[] {
    if (!waypoints || waypoints.length === 0) {
      return [];
    }
    let sortedWaypoints: Waypoint[] = [];
    let startWaypoint: Waypoint | undefined = waypoints.find((waypoint: Waypoint): boolean => waypoint.waypointTypeId === WaypointType.START_WAYPOINT);
    let finishWaypoint: Waypoint | undefined = waypoints.find((waypoint: Waypoint): boolean => waypoint.waypointTypeId === WaypointType.FINISH_WAYPOINT);
    if (startWaypoint) {
      sortedWaypoints.push(startWaypoint);
    }
    sortedWaypoints = [...sortedWaypoints, ...waypoints.filter((waypoint: Waypoint) => waypoint.waypointTypeId !== WaypointType.START_WAYPOINT && waypoint.waypointTypeId !== WaypointType.FINISH_WAYPOINT).sort(this._compare)];
    if (finishWaypoint) {
      sortedWaypoints.push(finishWaypoint);
    }
    return sortedWaypoints;
  }

  _compare(waypointA: Waypoint, waypointB: Waypoint): number {
    if (waypointA.waypointTypeId === WaypointType.OTHER_WAYPOINT && waypointB.waypointTypeId === WaypointType.OTHER_WAYPOINT) {
      return 0;
    } else if (waypointA.waypointTypeId === WaypointType.OTHER_WAYPOINT && waypointB.waypointTypeId === WaypointType.CONTROL_WAYPOINT) {
      return 1;
    } else if (waypointA.waypointTypeId === WaypointType.CONTROL_WAYPOINT && waypointB.waypointTypeId === WaypointType.OTHER_WAYPOINT) {
      return -1;
    } else {
      return waypointA.ordinalNumber! - waypointB.ordinalNumber!;
    }
  }
}
